var map = {
	"./welcome-bg1.png": 70,
	"./welcome-bg10.png": 71,
	"./welcome-bg11.png": 72,
	"./welcome-bg12.png": 73,
	"./welcome-bg13.png": 74,
	"./welcome-bg2.png": 75,
	"./welcome-bg3.png": 76,
	"./welcome-bg4.png": 77,
	"./welcome-bg5.png": 78,
	"./welcome-bg6.png": 79,
	"./welcome-bg7.png": 80,
	"./welcome-bg8.png": 81,
	"./welcome-bg9.png": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;